<div class="box-shadow module">
    <h2>{{'GenericErrorTitle'|translate}}</h2>
    <h4>{{'GenericErrorDescription'|translate}}</h4>

</div>
